import { render, staticRenderFns } from "./partnershipAdmin.vue?vue&type=template&id=1f7d9466"
import script from "./partnershipAdmin.vue?vue&type=script&lang=js"
export * from "./partnershipAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports